import {
  AfterViewInit,
  Directive,
  ElementRef,
  HostListener
} from '@angular/core';

@Directive({
  selector: '[sgtAutosize]',
})
export class AutoSizeDirective implements AfterViewInit {
  private textArea: HTMLTextAreaElement;
  private minRows = 1;

  // Constantes para estilos padrão
  private readonly DEFAULT_RESIZE = 'none';
  private readonly DEFAULT_OVERFLOW = 'hidden';
  private readonly DEFAULT_BOX_SIZING = 'border-box';

  // Constantes para cálculos numéricos
  // valor para converter string para número
  private readonly DECIMAL_BASE = 10;
  // Valor padrão para calcular line-height(120% do font-size)
  private readonly DEFAULT_LINE_HEIGHT_MULTIPLIER = 1.2;
  // Valor padrão para padding/border quando não calculáveis
  private readonly DEFAULT_SPACING_VALUE = 0;

  constructor(private el: ElementRef) {}

  ngAfterViewInit() {
    this.textArea = this.el.nativeElement;
    if (this.textArea && this.textArea.tagName === 'TEXTAREA') {
      this.initAutoResize();
      this.adjustHeight();
    }
  }

  private initAutoResize(): void {
    this.textArea.style.resize = this.DEFAULT_RESIZE;
    this.textArea.style.overflow = this.DEFAULT_OVERFLOW;
    this.textArea.style.boxSizing = this.DEFAULT_BOX_SIZING;

    // Calcula o número mínimo de linhas baseado no atributo rows
    if (this.textArea.rows) {
      this.minRows = this.textArea.rows;
    }
  }

  private adjustHeight(): void {
    if (!this.textArea) {
return;
}

    // Reseta altura(height) para calcular a altura do content(com ou sem scroll)
    this.textArea.style.height = 'auto';

    // Calcula a altura da linha(line height)
    const styles = window.getComputedStyle(this.textArea);
    const lineHeight =
      parseInt(styles.lineHeight, this.DECIMAL_BASE) ||
      parseInt(styles.fontSize, this.DECIMAL_BASE) * this.DEFAULT_LINE_HEIGHT_MULTIPLIER;
    const paddingTop = parseInt(styles.paddingTop, this.DECIMAL_BASE) || this.DEFAULT_SPACING_VALUE;
    const paddingBottom = parseInt(styles.paddingBottom, this.DECIMAL_BASE) || this.DEFAULT_SPACING_VALUE;
    const borderTop = parseInt(styles.borderTopWidth, this.DECIMAL_BASE) || this.DEFAULT_SPACING_VALUE;
    const borderBottom = parseInt(styles.borderBottomWidth, this.DECIMAL_BASE) || this.DEFAULT_SPACING_VALUE;

    // Calcula altura(height) mínima
    const minHeight =
      lineHeight * this.minRows +
      paddingTop +
      paddingBottom +
      borderTop +
      borderBottom;

    // Define a altura(height) para altura do content(com ou sem scroll) ou altura mínima, o que for maior
    const newHeight = Math.max(this.textArea.scrollHeight, minHeight);
    this.textArea.style.height = `${newHeight}px`;
  }

  @HostListener('input', ['$event'])
  onInput(): void {
    this.adjustHeight();
  }

  @HostListener('focus', ['$event'])
  onFocus(): void {
    this.adjustHeight();
  }

  @HostListener('blur', ['$event'])
  onBlur(): void {
    this.adjustHeight();
  }
}
